export * from './admin.component';
export * from './dashboard/dashboard.component'
export * from './mainadmin/mainadmin.component';
export * from './patient/patient.component';
